import styled, {keyframes} from 'styled-components'

const Rotator = keyframes`
	100% {
		transform: rotate(360deg);
	}
`

const Dash = keyframes`
	0% {
		stroke-dasharray: 1,200;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 89, 200;
		stroke-dashoffset: -35px;
	}
	100% {
		stroke-dasharray: 89, 200;
		stroke-dashoffset: -124px;
	}
`

export const SpinnerOverlay = styled.div`
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(var(--ontario-colour-greyscale-white), 0.7);
  z-index: 9999;

  &[aria-hidden='false'] {
    display: block;
  }

  &[aria-hidden='true'] {
    display: none;
  }
`

export const StyledSpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 100%;

  svg {
    animation: ${Rotator} 1.5s linear infinite;
    width: 3rem;
    height: 3rem;
    overflow: visible;

    circle {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
      stroke-linecap: round;
      stroke: var(--ontario-colour-greyscale-greyscale70);
      animation: ${Dash} 1.5s ease-in-out infinite;
    }
  }
`

export const SpinnerText = styled.p`
  color: var(--ontario-colour-greyscale-greyscale70);
  font-family: 'Raleway', 'Open Sans', 'Helvetica Neue', Helvetica, Arial,
    sans-serif;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
  margin: var(--ontario-spacing-3) var(--ontario-spacing-0)
    var(--ontario-spacing-0);
  word-spacing: 0.025rem;
`

export default {
  SpinnerOverlay,
  StyledSpinnerContainer,
  SpinnerText,
}
